import React, { useEffect, useState } from "react";
import {
  getNotificationSetting,
  saveNotificationSettings
} from "../../redux/services/notification.service";
import { toast } from "react-toastify";

export default function NotificationManagementModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const [rows, setRows] = useState([]);
  useEffect(() => {
    const notificationSetting = async () => {
      const response = await getNotificationSetting();
      if (response?.statusCode === 200) {
        setRows(response.data);
      }
    };
    notificationSetting();
  }, []);

  const handleSave = async () => {
    const payload = rows.map((item) => ({
      NotificationUserRelationId: item.notificationUserRelationId,
      notificationTemplateId: item.notificationTemplateId,
      isNotificationEnabled: item.isNotificationEnabled,
      isEmailEnabled: item.isEmailEnabled
    }));
    var response = await saveNotificationSettings(payload);
    if (response?.statusCode === 200) {
      toast.success("Updated successfully!");
      onClose();
    }
  };

  const toggle = (id, field) => {
    setRows((prev) =>
      prev.map((item) =>
        item.notificationTemplateId === id ? { ...item, [field]: !item[field] } : item
      )
    );
  };

  const renderTable = (title, groupId) => {
    const data = rows.filter((x) => x.notificationTypeId === groupId);

    return (
      <div className="mb-4">
        <table className="table table-hover align-middle table-borderless rounded-1">
          <thead>
            <tr className="bg-primary">
              <th className="text-white" style={{ width: "70%" }}>
                {title}
              </th>
              <th className="text-center text-white" style={{ width: "15%" }}>
                Notification
              </th>
              {/* <th className="text-center text-white" style={{ width: "15%" }}>
                Email
              </th> */}
            </tr>
          </thead>

          <tbody>
            {data.map((row) => (
              <tr key={row.notificationTemplateId}>
                <td>{row.notificationText}</td>

                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={row.isNotificationEnabled}
                    onChange={() => toggle(row.notificationTemplateId, "isNotificationEnabled")}
                  />
                </td>
                {/* 
                <td className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={row.isEmailEnabled}
                    onChange={() => toggle(row.notificationTemplateId, "isEmailEnabled")}
                  />
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="container py-4">
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-xl modal-dialog-centered p-5">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">Notification Management</h5>

              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            <div className="modal-body">
              {renderTable("Actions Required", 1)}

              {renderTable("General", 2)}
            </div>

            <div className="modal-footer">
              <button className="btn btn-primary" onClick={handleSave}>
                Save
              </button>

              <button className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
